import React, { createContext, useContext, ReactNode } from 'react';
import { useQuery } from '@apollo/client/react';
import { GetLoggedInUserDocument, GetLoggedInUserQuery } from 'graphql/queries.generated';

type User = NonNullable<GetLoggedInUserQuery['loggedInUser']>;

interface UserContextValue {
  user: User | null;
  loading: boolean;
  error: unknown;
  refetch: () => void;
}

const UserContext = createContext<UserContextValue | undefined>(undefined);

interface UserProviderProps {
  children: ReactNode;
}

export const UserProvider: React.FC<UserProviderProps> = ({ children }) => {
  const { data, loading, error, refetch } = useQuery(GetLoggedInUserDocument, {
    errorPolicy: 'all',
  });

  const value: UserContextValue = {
    user: data?.loggedInUser || null,
    loading,
    error,
    refetch: () => {
      refetch();
    },
  };

  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
};

export const useUser = (): UserContextValue => {
  const context = useContext(UserContext);
  if (context === undefined) {
    throw new Error('useUser must be used within a UserProvider');
  }
  return context;
};

